<template>
  <div class="property-search-content-listing-toggleable position-relative">
    <property-search-map
        v-show="renderMap || isMapHiddenByVisibilityOnly"
        :location="location"
        :property-details-route="propertyDetailsRoute"
        :favorite-option-enabled="favoriteOptionEnabled"
        :map-config="mapConfig"
        :content-height="contentHeight"
    />

    <property-listing
        v-show="!renderMap || isMapHiddenByVisibilityOnly"
        :property-details-route="propertyDetailsRoute"
        :favorite-option-enabled="favoriteOptionEnabled"
        :display-info-cards="!tabDisplay"
        :content-height="contentHeight"
    />

    <div class="tw-absolute tw-w-[18.438rem] tw-z-[100] tw-bg-white tw-left-1/2 tw-ml-[-9.375rem] tw-bottom-24">
      <property-search-content-listing-mode-toggle
          :render-map="renderMap"
          @toggle="$emit('toggle')"
      />
    </div>
  </div>
</template>

<script>
    import "./PropertySearchContentListingToggleable.scss";
    import PropertySearchMap from "../../PropertySearchMap/PropertySearchMap";
    import PropertyListing from "../../../GroupPropertyListing/PropertyListing/PropertyListing";
    import PropertySearchContentListingModeToggle
        from "../PropertySearchContentListingModeToggle/PropertySearchContentListingModeToggle";

    export default {
        name: "PropertySearchContentListingToggleable",
        components: {PropertySearchContentListingModeToggle, PropertyListing, PropertySearchMap},

        props: {
            location: {
                type: Array,
                required: true,
            },
            propertyDetailsRoute: {
                type: [String, Object],
                required: true,
            },
            favoriteOptionEnabled: {
                type: Boolean,
                required: true,
            },
            tabDisplay: {
                type: Boolean,
                required: true,
            },
            renderMap: {
                type: Boolean,
                required: true,
            },
            isMapHiddenByVisibilityOnly: {
                type: Boolean,
                required: true,
            },
            mapConfig: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            contentHeight: {
                type: Number,
                default: 0,
            }
        },
    };
</script>
